/**
 * Axios stores request data in an error config after transformRequest.
 * For JSON requests that value can already be a serialized string.
 * Decode it before saving an operation to IndexedDB or replaying a legacy
 * queue item, otherwise a task becomes a string with no `title` field.
 */
export function decodeRequestData(data) {
  if (typeof data !== 'string') return data;

  const trimmed = data.trim();
  if (!trimmed) return data;

  try {
    return JSON.parse(trimmed);
  } catch {
    return data;
  }
}

